/* eslint-disable max-len */
import { SvgProps } from './types'

export const BidAuctionIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="41" 
      height="40" 
      viewBox="0 0 41 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M22.167 35.0068H35.5003" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round"/>
      <path d="M16.3333 20.84L10.5 15.0067M16.3333 20.84L22.1667 26.6733M16.3333 20.84L3.83333 33.34M10.5 15.0067L17.1667 8.34001M10.5 15.0067L8.83333 16.6733M17.1667 8.34001L28.8333 20.0067M17.1667 8.34001L18.8333 6.67334M28.8333 20.0067L22.1667 26.6733M28.8333 20.0067L30.5 18.34M22.1667 26.6733L20.5 28.34" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
